import FacebookIcon from '../Assets/FaceBookIcon.svg'
import LinkedInIcon from '../Assets/LinkedInIcon.png';
import TwitterIcon from '../Assets/TwitterIcon.svg';
export const SocialMediaIconsArray=[


    {SocialMediaIcon:FacebookIcon,
        SocialMediLink:"https://www.facebook.com/profile.php?id=61557301585575"

    },
    {
        SocialMediaIcon:TwitterIcon,
        SocialMediLink:"https://x.com/agilewitsol"   
    },
{
    SocialMediaIcon:LinkedInIcon,
    SocialMediLink:"https://www.linkedin.com/company/agilewits-solutions/?viewAsMember=true"
}
    

]
export const BottomPageContent = {
    Explore: "EXPLORE",
    AboutUs: "About Us",
    AppDevelopment: "App Development",
    Career: "Careers",
    Training: "Training",
    CurrentOpenings: "Current Openings",
    Service: "SERVICES",
    Consulting: "CONSULTING",
    Product: "PRODUCT",
    Consent: "CONSEN",
    Contact: "CONTACT",
    CompanyUSAAddress: `USA:
                        800 sedona st little elm 75068
                        Phone Number: (516) 888-0089`,
    CompanyIndiaAddress: ` India: H.No.1-90/7/53/P, Second Floor Blossom Heights, Plot No. 53 
    Patrika Nagar, Madhapur Hyderabad, Telangana`,
    CompanyMail: "Reachus@ravbs.com",
    EndTitle: "© Rav Business Stream LLC"
};
